<script setup lang="ts">
import { onMounted, ref } from "vue";

defineProps({
    modelValue: {
        type: String,
        required: false,
    },
});

const emit = defineEmits(["update:modelValue"]);

const input = ref<HTMLInputElement | null>(null);

function onInput(event: InputEvent) {
    if (event.target) {
        emit("update:modelValue", (event.target as HTMLInputElement).value);
    }
}

onMounted(() => {
    if (input.value!.hasAttribute("autofocus")) {
        input.value!.focus();
    }
});

defineExpose({ focus: () => input.value!.focus() });
</script>

<template>
    <input
        class="border-gray-300 focus:border-primary-500 focus:ring-primary-500 rounded-md shadow-sm"
        :value="modelValue"
        @input="onInput"
        ref="input"
    />
</template>
